import { getSupportedFormatLocale } from "../getSupportedFormatLocale";
import { useMemo } from "react";
import { DateTimeFormat } from "../temporal";
export function useDateTimeFormat(options, locale) {
    return useMemo(() => new DateTimeFormat(locale !== null && locale !== void 0 ? locale : getSupportedFormatLocale("dateTime"), options), [options]);
}
//# sourceMappingURL=useDateTimeFormat.js.map